import script from "./TestimonialLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialLanding.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialLanding.vue?vue&type=style&index=0&id=6bebc4ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bebc4ba"]])

export default __exports__